module.exports = __webpack_public_path__ + "img/rank3.c87df522.png";